import { render, staticRenderFns } from "./SmartListsNewReferrers.vue?vue&type=template&id=572978ab"
import script from "./SmartListsNewReferrers.vue?vue&type=script&lang=js"
export * from "./SmartListsNewReferrers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports